import fetchWithUuid from "./fetchWithUuid";
import checkError from "./checkError";
import {
  actionTypes,
  apiStatuses,
  Deferred,
  FindUserByPhoneNumber,
  IFindUserByEmailOrPhoneResult,
  productInfoDeferred
} from "./Actions";
import createLink1And2AsUrlParams from "./createLink1And2AsUrlParams";

const findUserByPhoneNumber: FindUserByPhoneNumber = (
  phoneNumber,
  email,
  linkHasPaymentMethod,
  linkNoPaymentMethod
) => dispatch => {
  const failedCallback = (data: any) => {
    dispatch({
      data,
      status: apiStatuses.ERROR,
      type: actionTypes.FIND_USER_BY_PHONE_NUMBER
    });
    return findUserByPhoneNumberDeferred.reject(data);
  };

  const findUserByPhoneNumberDeferred = new Deferred<IFindUserByEmailOrPhoneResult>();
  dispatch({
    status: apiStatuses.LOADING,
    type: actionTypes.FIND_USER_BY_PHONE_NUMBER
  });

  productInfoDeferred.promise.then(productInfo => {
    const phoneNumberUriEncoded = encodeURIComponent(phoneNumber);
    fetchWithUuid(
      `/bestilling/c/${
        productInfo.owningClient
      }/api/v2/users/phoneTrigger/${phoneNumberUriEncoded}.json?email=${encodeURIComponent(
        email
      )}&${createLink1And2AsUrlParams(
        linkHasPaymentMethod,
        linkNoPaymentMethod
      )}`
    )
      .then(checkError)
      .then(res => res.json())
      .then(data => {
        dispatch({
          data,
          status: apiStatuses.SUCCESS,
          type: actionTypes.FIND_USER_BY_PHONE_NUMBER
        });
        return findUserByPhoneNumberDeferred.resolve(data);
      })
      .catch(failedCallback);
  }, failedCallback);

  return findUserByPhoneNumberDeferred.promise;
};

export default findUserByPhoneNumber;
